import React from 'react';
import { CheckboxGroupItemProps } from './types';
import { NoSSRComponent } from '@/migrated-widgets/table-map/utils/ssr';

function CheckboxGroupItemComponent({ children, onHoverClass = 'hover:bg-gray-200 duration-200', textAlign = 'text-left', padding = 'p-1', cursor = 'cursor-pointer', className, ...rest }: CheckboxGroupItemProps) {
  return (
    <div className={
      [cursor, 'rounded', onHoverClass, textAlign, padding, className].join(' ')
    }  {...rest}>
      {children}
    </div>
  )
}

export const CheckboxGroupItem = NoSSRComponent(CheckboxGroupItemComponent);